// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getPerformance } from "firebase/performance";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAhTxHORwri2TWJSI6TElQVPyzkJHRfclo",
  authDomain: "process-vision.firebaseapp.com",
  projectId: "process-vision",
  storageBucket: "process-vision.appspot.com",
  messagingSenderId: "858093844004",
  appId: "1:858093844004:web:c2d3d4451bb2ae285ecab1",
  measurementId: "G-GQPNRK97V7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const performance = getPerformance(app);
export { auth, provider, performance };
